<div class="row mt-5 justify-content-end mb-4">
    <div class="col-md-4">
        <span style="font-weight: bold;" [ngStyle]="{'color': statusColor}">{{komentar}}</span>
    </div>    
    <div class="col-md-8">
        <!-- <span style="font-weight: bold;" [ngStyle]="{'color': statusColor}">{{komentar}}</span> -->
        <div class="row mt-2" *ngIf="!ino">
            <div class="col-md-2"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">{{ 'FAKDOKUMENT.SUM.VREDNOSTDOBARIUSLUGA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{vrednost}}</div>
        </div>
        <div class="row mt-2" *ngIf="ino">
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>
            <div class="col-md-2">{{ 'FAKDOKUMENT.SUM.VREDNOSTDOBARIUSLUGA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{vrednostIno}}</div>
            <div class="col-md-1 text-left font-weight-bold">{{valutaISOAlpha3Code}}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{vrednost}}</div>
            <div class="col-md-1 text-left font-weight-bold">RSD</div>
        </div>
        <div class="row mt-2" *ngIf="!ino || imaAvans">
            <div class="col-md-5" *ngIf="imaAvans && !ino">{{ 'FAKDOKUMENT.SUM.UPLACENIAVANSI' | translate }} {{avansi}}</div>
            <div class="col-md-5" *ngIf="!imaAvans || ino"></div>
            <div class="col-md-3">{{ 'FAKDOKUMENT.SUM.RABAT' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{rabatvred}}</div>
        </div>
        <div class="row mt-2" *ngIf="ino">
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>          
            <div class="col-md-2">{{ 'FAKDOKUMENT.SUM.RABAT' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{rabatIno}}</div>
            <div class="col-md-1 text-left font-weight-bold">{{valutaISOAlpha3Code}}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{rabatvred}}</div>
            <div class="col-md-1 text-left font-weight-bold">RSD</div>
        </div>
        <div class="row mt-2" *ngIf="!ino || imaAvans">
            <div class="col-md-2" *ngIf="imaAvans">{{ 'FAKDOKUMENT.SUM.AVANSOSNOVICA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border " *ngIf="imaAvans">{{avansOsnovica}}</div>    
            <div class="col-md-5" *ngIf="!imaAvans"></div>
            <div class="col-md-3">{{ 'FAKDOKUMENT.SUM.OSNOVICA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{osnovica}}</div>
            <!-- <div class="col-md-3" *ngIf="ino">Ukupno:</div>
            <div class="col-md-3 text-right font-weight-bold border" *ngIf="ino">{{osnovica}}</div> -->
        </div>  
        <div class="row mt-2" *ngIf="ino">
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>          
            <div class="col-md-2">{{ 'FAKDOKUMENT.SUM.OSNOVICA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{ukupnoIno}}</div>
            <div class="col-md-1 text-left font-weight-bold">{{valutaISOAlpha3Code}}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{osnovica}}</div>
            <div class="col-md-1 text-left font-weight-bold">RSD</div>
        </div>     
        <div class="row mt-2" *ngIf="!ino || imaAvans">
            <div class="col-md-2" *ngIf="imaAvans">{{ 'FAKDOKUMENT.SUM.AVANSPDV' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border" *ngIf="imaAvans">{{avansPdv}}</div>  
            <div class="col-md-5" *ngIf="!imaAvans"></div>
            <div class="col-md-3">{{ 'FAKDOKUMENT.SUM.PDV' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{porez}}</div>
        </div>
        <div class="row mt-2" *ngIf="ino">
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>          
            <div class="col-md-2">{{ 'FAKDOKUMENT.SUM.PDV' | translate }}</div>
            <div class="col-md-3"></div>
            <div class="col-md-1"></div>
            <div class="col-md-3 text-right font-weight-bold border">{{porez}}</div>
            <div class="col-md-1 text-left font-weight-bold">RSD</div>
        </div>     
        <div class="row mt-2" *ngIf="!ino || imaAvans">
            <div class="col-md-2" *ngIf="imaAvans">{{ 'FAKDOKUMENT.SUM.UKUPNOAVANS' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border" *ngIf="imaAvans">{{avansUkupno}}</div>
            <div class="col-md-5" *ngIf="!imaAvans"></div>
            <div class="col-md-3">{{ 'FAKDOKUMENT.SUM.UKUPNO' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{ukupno}}</div>
        </div>
        <div class="row mt-2" *ngIf="ino">
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>
            <div class="col-md-2">{{ 'FAKDOKUMENT.SUM.UKUPNO' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{ukupnoIno}}</div>
            <div class="col-md-1 text-left font-weight-bold">{{valutaISOAlpha3Code}}</div>
            <div class="col-md-3 text-right font-weight-bold border">{{ukupno}}</div>
            <div class="col-md-1 text-left font-weight-bold">RSD</div>
        </div>
        <div class="row mt-2" *ngIf="imaKorekciju">
            <div class="col-md-2"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3" *ngIf="!ino">{{ 'FAKDOKUMENT.SUM.KOREKCIJA' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border" *ngIf="!ino">{{korekcija}}</div>
        </div>
        <div class="row mt-2" *ngIf="imaAvans || imaKorekciju">
            <div class="col-md-2"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3" *ngIf="!ino">{{ 'FAKDOKUMENT.SUM.UKUPNOZAUPLATU' | translate }}</div>
            <div class="col-md-3 text-right font-weight-bold border" *ngIf="!ino">{{ukupnoZaUplatu}}</div>
        </div>
    </div>
</div>